import React, { useEffect, useContext, useState,useRef } from "react";
import { useHistory } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  tableLoading,
  formatNumber,
  formatPrice,
  customStyle
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//pages & includes
import AccountsSidebar from "../AccountsSidebar";
import NumberFormatter from "../../../component/NumberFormatter";

//context consumer
import { UserContext } from "../../../../../contexts/User";
import { FinanceContext } from "../../../../../contexts/Finance";
import { RestaurantContext } from "../../../../../contexts/Restaurant";

const AddJournalVoucher = () => {
    const { t } = useTranslation();
    const history = useHistory();
    //getting context values here
    let { getSupplier, supplierForSearch } = useContext(UserContext);
    const { branchForSearch } = useContext(RestaurantContext)
    //finance context
    const {
      loading,
      setLoading,

      //coa3
      cao3Active,

      //JVList
      setJournalVoucherList,
      setJournalVoucherListForSearch,

      //pagination
      dataPaginating,        
    } = useContext(FinanceContext);
    // States hook here
    //Add new row
    const [newRow,setNewRow]=useState([]);

    //Journal voucher state
    const [journalVoucher,setJournalVoucher]=useState({
      doc_date:new Date(),
      branch:"",
      remarks:""
    });

     //print bills
    //  const componentRef = useRef();
  
    //useEffect == componentDidMount()
    useEffect(() => {
      // getFoodWeb();
      if(!supplierForSearch){
        getSupplier();
      }
    }, []);

    const saveAccount=async(formData)=>{
      setLoading(true);
  
      const url = BASE_URL + "/settings/create-journal-voucher";
       await axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
      .then((res) => {                
        setJournalVoucherList(res.data[0]);
        setJournalVoucherListForSearch(res.data[1]);
        setLoading(false);
        toast.success(`${_t(t("Voucher has been added"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        history.push("/dashboard/account/transaction/journal-voucher");
      }).catch((error) =>{
        setLoading(false);
        toast.error(`${_t(t("Please try again later"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      })
    }
    
    const handleSubmit=(e)=>{
      e.preventDefault();
      if(!journalVoucher.branch){
        toast.error(`${_t(t("Please select branch"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        return
      }
      if(newRow.length>0){
        let noFilledRows=newRow.length>0 && newRow.filter((v,i)=> v.account_name == "")
        if(noFilledRows.length>0){
          toast.error(`${_t(t("Please select account name"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        }else{
          let debit = totalDebit();
          let credit = totalCredit();
          if(debit === credit){
            const newArr = newRow.map((v) => {
              let obj={ 
                coa_account_id:v.account_name.id,
                supplier_id: v.supplier ? v.supplier.id : 0,
                cheque_date: v.cheque_date ? (v.cheque_date.getFullYear() + "-" + (parseInt(v.cheque_date.getMonth()) + 1) + "-" + v.cheque_date.getDate()) : "",
                cheque_no:v.cheque_no,
                debit: isNaN(parseFloat(v.debit)) || v.debit==="" ? 0 : parseFloat(v.debit),
                credit:isNaN(parseFloat(v.credit)) || v.credit==="" ? 0 : parseFloat(v.credit),
                remarks:v.remarks
              }
              return obj;
            })
            let docDate = journalVoucher.doc_date.getFullYear() + "-" + (parseInt(journalVoucher.doc_date.getMonth()) + 1) + "-" + journalVoucher.doc_date.getDate();
            let saveObj={
              document_date:docDate,          
              remarks:journalVoucher.remarks,
              branch_id:journalVoucher.branch.id,
              rows:newArr,
              total_debit:totalDebit(),
              total_credit:totalCredit(),
            }
            // console.log("check save==>",saveObj);
            saveAccount(saveObj)
          }
          else{
            toast.error(`${_t(t("Debit and Credit must be equal"))}`, {
              position: "bottom-center",
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              className: "text-center toast-notification",
            });
          }
        }
      }else{
        toast.error(`${_t(t("Please add vouchers"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }
    }
  
  
    const handleDocDate=(date)=>{
      setJournalVoucher({
        ...journalVoucher,
        doc_date:date
      })
    }

    const handleBranch=(branch)=>{
      setJournalVoucher({
        ...journalVoucher,
        branch
      })
    } 
    
    const handleRemarks = (remarks) =>{
      setJournalVoucher({
        ...journalVoucher,
        remarks
      })
    }
    
    const [rowId,setRowId]=useState(0);
    const addNewRow=()=>{      
      setNewRow((pre)=>[...pre,{
        id:rowId,
        account_name:"",
        supplier:"",
        remarks:"",
        cheque_date: null,
        cheque_no:"",
        debit:"",
        credit:""
      }])
      setRowId(rowId+1);
    }
    const delRow=(id)=>{
      let row=[...newRow]
      row= row.filter((item,i)=>id!==item.id);
      setNewRow(row);
    }

    const handleAccountName=(index,acc)=>{
      newRow[index].account_name=acc  
      setNewRow([...newRow]);
    }
    const handleSetSupplier = (index,supplier) => {
      newRow[index].supplier=supplier  
      setNewRow([...newRow]);
    };

    const handleRowRemarks=(index,e)=>{
      newRow[index].remarks = e.target.value;
      setNewRow([...newRow]);
    }

    const handleChequeDate=(index,date)=>{
      newRow[index].cheque_date=date 
      setNewRow([...newRow]);
    }

    const handleChequeNo=(index,e)=>{
      newRow[index].cheque_no = e.target.value;
      setNewRow([...newRow]);
    }

    const handleDebit=(index,e)=>{
      newRow[index].debit=e.target.value;
      setNewRow([...newRow]) 
      if(e.target.value !== ""){
        newRow[index].credit = ""
        setNewRow([...newRow])
      }
    }

    const handleCredit=(index,e)=>{
      newRow[index].credit=e.target.value
      setNewRow([...newRow])
      if(e.target.value !== ""){
        newRow[index].debit = ""
        setNewRow([...newRow])
      } 
    }
     
    const totalDebit=()=>{
      let total = 0;
      if (newRow !== null && newRow.length > 0) {
        newRow.map((item) => {
          // if(item.amount){
          total = total + (isNaN(item.debit) || item.debit == "" ? 0 : parseFloat(item.debit));
          // }
        });
      }
      // setTotalRowDebit(total)
      return total;
    }

    const totalCredit=()=>{
      let total = 0;
      if (newRow !== null && newRow.length > 0) {
        newRow.map((item) => {
          // console.log("check total amount==>",(isNaN(item.amount) || item.amount=="" ? 0 : parseInt(item.amount)));
          // if(item.amount){
            total = total + (isNaN(item.credit) || item.credit=="" ? 0 : parseFloat(item.credit));
          // }
        });
      }
      // setTotalRowCredit(total);
      return total;
    }

    return (
      <>
      <Helmet>
        <title>{_t(t("Add Journal Voucher"))}</title>
      </Helmet>
  
      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
                <AccountsSidebar />
            </div>
            {/* left Sidebar ends */}
  
            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <div className={`${dataPaginating && "loading"}`}></div>
                    {/* spin loading ends */}
  
                    {/* Loading effect */}
                    {loading === true ? (
                      tableLoading()
                    ) : (
                      <div key="smtp-form">
                        <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                          <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                            <ul className="t-list fk-breadcrumb">
                              <li className="fk-breadcrumb__list">
                                <span className="t-link fk-breadcrumb__link text-capitalize">
                                  {_t(t("Add Journal Voucher"))}
                                </span>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-6 col-lg-7">
                            <div className="row gx-3 align-items-center"></div>
                          </div>
                        </div>
  
                        {/* Form starts here */}
                        <form
                          className="row card p-2 mx-3 mb-5 table-text"
                          onSubmit={handleSubmit}
                          autoComplete="off"
                        >
                          <div className="col-12">
                            <div className="row">
                              <div className="form-group col-4 mt-2">
                                <div className="mb-2">
                                  <label
                                    htmlFor="invoice"
                                    className="control-label"
                                  >
                                    {_t(t("Document #"))}
                                  </label>
                                </div>
                                <div className="mb-2">
                                  <input
                                    disabled={true}
                                    type="text"
                                    className="form-control table-text"
                                    id="invoice"
                                    name="invoice"
                                    // onChange={handleChange}
                                    // value={newItem.invoice}
                                    placeholder="Auto No"
                                  />
                                </div>
                              </div>

                              <div className="form-group col-4 text-right mt-2">
                                <div className="mb-2 text-left">
                                  <label
                                    htmlFor="purchaseDate"
                                    className="control-label"
                                  >
                                    {_t(t("Document Date"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <div className="mb-2">
                                  <DatePicker
                                    selected={journalVoucher.doc_date}
                                    onChange={(date) => handleDocDate(date)}
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    className="form-control table-text"
                                    placeholderText={_t(t("Document date"))}
                                    shouldCloseOnSelect={false}
                                    required
                                  />
                                </div>
                              </div>

                              <div className="form-group mt-2 col-4">
                                <div className="mb-2 text-left">
                                  <label
                                    htmlFor="branch"
                                    className="control-label"
                                  >
                                    {_t(t("Branch"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <Select
                                  options={branchForSearch ? branchForSearch : []}
                                  components={makeAnimated()}
                                  getOptionLabel={(option) => option.name}
                                  getOptionValue={(option) => option.id}
                                  value={journalVoucher.branch || ""}
                                  classNamePrefix="select table-text"
                                  onChange={(branch)=>handleBranch(branch)}
                                  //maxMenuHeight="50px"
                                  placeholder={
                                    _t(t("Please select branch")) + ".."
                                  }
                                  styles={customStyle}
                                  required
                                />
                              </div>
                  
                              <div className="form-group mt-2 col-8">
                                <div className="mb-2">
                                  <label
                                    htmlFor="description"
                                    className="control-label"
                                  >
                                    {_t(t("Remarks"))}
                                  </label>
                                </div>
                                <div className="mb-2">
                                  <input
                                    type="text"
                                    className="form-control table-text"
                                    id="description"
                                    name="description"
                                    onChange={(e)=>handleRemarks(e.target.value)}
                                    value={journalVoucher.remarks}
                                    placeholder="Short description"
                                  />
                                </div>
                              </div>
                            </div>                           
                            <div className={`table-responsive pt-3 mt-2 pr-1`} style={{maxHeight:"21rem",overflow: "auto"}}>                              
                              <table className="table table-bordered-sm table-hover">
                                <thead className="align-middle">
                                  <tr>
                                    {newRow.length==0 ?<th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span className="t-mr-10" onClick={()=>addNewRow()}>
                                        <i className="fa fa-plus-circle cursor-pointer btn-add-icon" style={{fontSize:"22px"}} aria-hidden="true"></i>
                                      </span>
                                    </th>:<th style={{borderBottomColor:"lightgray"}}></th>}
                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border table-Child-bank"
                                    >
                                      <span style={{fontWeight:500}}>
                                        {_t(t("Account name"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border table-Child-bank"
                                    >
                                      <span style={{fontWeight:500}}>
                                        {_t(t("Supplier name"))}
                                      </span>
                                    </th>
                                  
                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{fontWeight:500}}>
                                        {_t(t("Remarks"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{fontWeight:500}}>
                                        {_t(t("Cheque Date"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{fontWeight:500}}>
                                        {_t(t("Cheque No"))}
                                      </span>
                                    </th>

                                    <th
                                    scope="col"
                                    className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                    <span style={{fontWeight:500}}>
                                      {_t(t("Debit"))}
                                    </span>
                                    </th>

                                    <th
                                    scope="col"
                                    className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                    <span style={{fontWeight:500}}>
                                      {_t(t("Credit"))}
                                    </span>
                                    </th>
                                      
                                  {newRow.length>0 && <th style={{borderBottomColor:"lightgray",minWidth:"60px"}}></th>}                                        
                                  </tr>
                                </thead>

                                <tbody className="align-middle">                                      
                                  {newRow.length > 0 ? newRow.map((v,i)=>{
                                    return <tr
                                        className="align-middle"
                                        key={i}
                                      >
                                        <td className="table-text text-capitalize align-middle text-center table-firstChild" style={{minWidth:"60px"}}>
                                        {i==(newRow.length-1) && <span className="t-mr-10" onClick={()=>addNewRow()}>
                                          <i className="fa fa-plus-circle btn-add-icon" style={{fontSize:"22px"}} aria-hidden="true"></i>
                                        </span>}&nbsp;
                                        <i className="fa fa-minus-circle cursor-pointer text-danger" style={{fontSize:"22px"}} onClick={()=>{delRow(v.id)}}></i>
                                        </td>
                                        <td className="table-text text-capitalize align-middle" style={{minWidth:"250px"}}>
                                          <Select
                                            menuPosition="fixed"
                                            menuPlacement={i >= 4 ? "top" : "bottom"}                                             
                                            options={cao3Active ? cao3Active : []}
                                            //components={makeAnimated()}
                                            getOptionLabel={(option) => option.level3_name}
                                            getOptionValue={(option) => option.id}
                                            value={v.account_name|| ""}
                                            classNamePrefix="select"
                                            onChange={(e)=>handleAccountName(i,e)}
                                            maxMenuHeight="13rem"
                                            placeholder={
                                              _t(t("Account Name")) + ""
                                            }
                                            isMenuOpen={true}
                                            styles={customStyle}
                                            className="bank-table-input"
                                            required                                                
                                          />
                                        </td>

                                        <td className="table-text text-capitalize align-middle" style={{minWidth:"250px"}}>
                                          <Select
                                            menuPosition="fixed"
                                            menuPlacement={i >= 4 ? "top" : "bottom"} 
                                            options={supplierForSearch ? supplierForSearch : []}
                                            components={makeAnimated()}
                                            getOptionLabel={(option) => option.name}
                                            getOptionValue={(option) => option.id}
                                            value={v.supplier}
                                            classNamePrefix="select table-text"
                                            onChange={(e)=>handleSetSupplier(i,e)}
                                            maxMenuHeight="13rem"
                                            isClearable
                                            placeholder={
                                              _t(t("Please select supplier")) + ".."
                                            }
                                            styles={customStyle}                                  
                                          />
                                        </td>

                                        <td className="table-text text-capitalize align-middle text-center" style={{minWidth:"140px"}}>
                                          <input
                                            type="text"                                              
                                            // step="0.1"
                                            // min="0"
                                            //onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                                            className="form-control text-center table-Input table-text"
                                            onChange={(e)=>handleRowRemarks(i,e)}                                              
                                            placeholder="remarks"                                              
                                            value={v.remarks}
                                          />
                                        </td>

                                        <td className="table-text text-capitalize align-middle text-center" style={{minWidth:"120px"}}>
                                          <DatePicker
                                            selected={v.cheque_date}
                                            onChange={(date) => handleChequeDate(i,date)}
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            className="form-control table-text"
                                            placeholderText={_t(t("Cheque date"))}
                                            shouldCloseOnSelect={false}                                                
                                          />
                                        </td>
                                        
                                        <td className="table-text text-capitalize align-middle text-center" style={{minWidth:"130px"}}>
                                        <input
                                          type="number"
                                          // step="0.1"
                                          min="0"
                                          onKeyDown={(evt) => ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) && evt.preventDefault()}
                                          onWheel={(e)=>{e.target.blur()}}
                                          className="form-control text-center table-Input table-text"
                                          onChange={(e)=>handleChequeNo(i,e)}
                                          value={v.cheque_no}
                                          placeholder="cheque no"                                                                                         
                                        />
                                        </td>                                            
                                        <td className="table-text text-capitalize align-middle text-center" style={{minWidth:"140px"}}>
                                          <NumberFormatter>
                                            <input
                                              type="text"
                                              step="0.01"
                                              min="0"
                                              onKeyDown={(evt) => ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) && evt.preventDefault()}
                                              onWheel={(e)=>{e.target.blur()}}
                                              className="form-control text-center table-Input table-text"
                                              onChange={(e)=>handleDebit(i,e)}
                                              placeholder="0"
                                              required = {!v.credit}
                                              value={v.debit}
                                            />
                                          </NumberFormatter>
                                        </td>
                                        <td className="table-text text-capitalize align-middle text-center" style={{minWidth:"140px"}}>
                                          <NumberFormatter>
                                            <input
                                              type="text"
                                              step="0.01"
                                              // min="0"
                                              onKeyDown={(evt) => ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) && evt.preventDefault()}
                                              onWheel={(e)=>{e.target.blur()}}
                                              className="form-control text-center table-Input table-text"
                                              onChange={(e)=>handleCredit(i,e)}
                                              value={v.credit}
                                              placeholder="0"
                                              required={!v.debit}
                                            />
                                          </NumberFormatter>
                                        </td>
                                        
                                        <td className="table-text text-capitalize align-middle text-center" style={{minWidth:"60px"}}>
                                          <i className="fa fa-minus-circle cursor-pointer text-danger" style={{fontSize:"22px"}} onClick={()=>{delRow(v.id)}}></i>&nbsp;
                                          {i==(newRow.length-1) && <span className="t-mr-10" onClick={()=>addNewRow()}>
                                            <i className="fa fa-plus-circle cursor-pointer btn-add-icon" style={{fontSize:"22px"}} aria-hidden="true"></i>
                                          </span>}
                                        </td>
                                    </tr>
                                  }):null}
                                </tbody>
                                {newRow.length > 0 &&
                                <tfoot className="align-middle">
                                  <tr>
                                    <th
                                    // style={{minWidth:"100px"}}
                                      scope="col"
                                      colSpan="6"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    ></th>                                        
                                      
                                    <th
                                      style={{minWidth:"100px"}}
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border font-weight-bold"
                                    >
                                      <span style={{fontWeight:"bold"}}>
                                        {formatNumber(formatPrice(totalDebit()))}
                                      </span>
                                    </th>
                                    <th
                                      style={{minWidth:"100px"}}
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border font-weight-bold"
                                    >
                                      <span style={{fontWeight:"bold"}}>
                                        {formatNumber(formatPrice(totalCredit()))}
                                      </span>
                                    </th>                                                                                
                                    <th
                                    // style={{minWidth:"100px"}}
                                      scope="col"
                                      // colSpan="3"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    ></th> 
                                  </tr>
                                </tfoot>}
                              </table>                                  
                            </div>
  
                            <div className="form-group mt-4 pb-2">
                              <div className="col-12 text-right">
                                <button
                                  className="btn hov-btn px-4 mr-3 rounded"
                                  onClick={()=>(history.push("/dashboard/account/transaction/journal-voucher"))}
                                >
                                  <i className="fa fa-arrow-left" aria-hidden="true"></i> {_t(t("Back"))}
                                </button>
                                <button
                                  className="btn btn-primary px-4 rounded"
                                  type="submit"
                                >
                                  <i className="fa fa-floppy-o" aria-hidden="true"></i> {_t(t("Save"))}
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
        {/* main body ends */}
        {/* <StockReport
        name = "Purchase Order"
        purchaseDate={purchaseOrderDate}
        newItem={newItem}
        qtyOfItem={qtyOfItem}
        rateOfItem={rateOfItem}
        handleGetTotal={handleGetTotal}
        handleAmount={handleAmount}
        handleTaxAmount={0}
        handleDisAmount={0}
        handleGetSubTotal={handleGetSubTotal}
        handleGetAmount={handleGetAmount}
        stockPrint={componentRef}
        /> */}
    </>
    )
}

export default AddJournalVoucher;